module.exports = __webpack_public_path__ + "img/bx-change-timetable-active.74353985.svg";